// extracted by mini-css-extract-plugin
module.exports = {"root":"root___2Ucf0","footer":"footer___2AA0D"};